import React, { FC } from 'react';

import { AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import cn from 'classnames';

import ChevronTopIcon from '../../assets/icons/ChevronTopIcon';
import { colorsPalette } from '../../theme';
import useTextStyles from '../../utils/textStyles';
import { useSingleAccordionStyles } from './styles';

interface SingleAccordionProps {
  id: number;
  title?: string | null;
  description?: string | null;
  isOpened: boolean;
  handleOpen: (index: number) => void;
}

const SingleAccordion: FC<SingleAccordionProps> = ({
  id,
  title,
  description,
  isOpened,
  handleOpen,
}) => {
  const textClasses = useTextStyles();
  const classes = useSingleAccordionStyles();
  return (
    <Accordion
      expanded={isOpened}
      onClick={() => handleOpen(id)}
      classes={{
        root: classes.accordionRoot,
        expanded: classes.accordionExpanded,
      }}
    >
      <AccordionSummary
        classes={{
          root: classes.accordionSummaryRoot,
          expanded: classes.accordionSummaryExpanded,
          content: classes.accordionSummaryContent,
        }}
        expandIcon={<ChevronTopIcon color={colorsPalette.violet} className={classes.icon} />}
      >
        <Typography variant="h4" className={textClasses.h4}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        classes={{
          root: classes.accountDetailsRoot,
        }}
      >
        <Typography className={cn(classes.description, textClasses.body)}>{description}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default SingleAccordion;
